import { useTranslation, Trans } from 'next-i18next'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import TimesBoldIcon from '~/components/Icons/svgs/TimesBoldIcon'
import { useAppDispatch } from '~/redux/hooks'
import { setShowAndroidAppModalCreator } from '~/redux/slices/modals'
import DownloadAppBadge from '~/shared/components/DownloadAppBadge'
import { MobileLogo } from '~/shared/layouts/components/HeaderTop/MobileLogo'

export default function GetAndroidAppModal(): React.ReactElement {
  const { t } = useTranslation('menu')
  const dispatch = useAppDispatch()

  const onClickClose = (): void => {
    dispatch(setShowAndroidAppModalCreator(false))
  }
  return (
    <div className="fixed bottom-0 flex flex-col items-center w-screen bg-pink-light py-3 z-modal-top">
      <div className="flex justify-center w-full mb-4 mx-auto">
        <span className="absolute left-2">
          <MobileLogo />
        </span>
        <h2 className="text-md text-center font-bold leading-none tracking-wide max-w-3/4">
          {Trans({
            t,
            i18nKey: 'getHomApp',
            components: { br: <br /> },
            children: t('getHomApp'),
          })}
        </h2>
        <button aria-label={t('close')} className="absolute scale-golden right-2 -mt-2" onClick={onClickClose}>
          <SVGIcon icon={TimesBoldIcon} pathClassName="text-purple" size={30} />
        </button>
      </div>
      <DownloadAppBadge onClick={onClickClose} width={154} />
    </div>
  )
}
